import { render, staticRenderFns } from "./OurProjectsBox.vue?vue&type=template&id=df9482e2&scoped=true"
import script from "./OurProjectsBox.vue?vue&type=script&lang=js"
export * from "./OurProjectsBox.vue?vue&type=script&lang=js"
import style0 from "./OurProjectsBox.vue?vue&type=style&index=0&id=df9482e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9482e2",
  null
  
)

export default component.exports